jQuery(document).ready(function ($) {
    let postNavigation = $('.post-nav-container');

    $(document).on('scroll', function () {
        let debounce;

        //clear the delay if it's not finished yet
        if (debounce) {
            clearTimeout(debounce);
        }

        //start a new delay
        debounce = setTimeout(function () {
            //remove reference so another delay can start
            debounce = null;

            // show/hide the button
            if ($(window).scrollTop() > 200) {
                postNavigation.addClass('show');
            } else {
                postNavigation.removeClass('show');
            }
        }, 200);
    });
});
